import React, { useEffect, useState } from 'react'
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { auditNav } from '../components/NavigationPath';
import Loader from '../components/Loader';
import Layout2 from '../components/Layout2'
import PageHeader from '../components/PageHeader';
import { useAudit } from '../contexts/AuditContext';
import { useAuth } from '../contexts/AuthContext';

const Audit = () => {
  const { getAllAudits } = useAudit();
  const { restaurantId } = useAuth();
  
  const [auditList, setAuditList] = useState();
  const [sortField, setSortField] = useState('created_at');
  const [sortOrder, setSortOrder] = useState(-1);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState("");

  const fetchAudits = async () => {
    try {
      setIsLoading(true)
      let apiSortField = sortField === "userName" ? "first_name" : sortField; 
      let audits = await getAllAudits({ page: currentPage, limit: rowsPerPage, sortField: apiSortField, sortOrder, search: filter });
      if (audits.length !== 0) {
        setAuditList(audits.audits)
        setTotalRecords(audits.totalCount)
      }
      setIsLoading(false)
    } catch (error) {
      console.error('Error fetching audits', error);
    }
  }

  const onPageChange = (event) => {
    const newCurrentPage = Math.floor(event.first / event.rows) + 1;
    setCurrentPage(newCurrentPage);
    const newRowsPerPage = event.rows;
    setRowsPerPage(newRowsPerPage);
  };


  const handleSubmit = async (e) => {
    e.preventDefault()
    fetchAudits();
  };
  
  const handleSorting = async (e) => {
    const field = e.sortField;
    const order = e.sortOrder;

    setSortField(field);
    setSortOrder(order);
    fetchAudits()
  };

  useEffect(() => {
    if (restaurantId) {
      fetchAudits()
    }
  }, [currentPage, rowsPerPage, sortField, sortOrder, restaurantId])

  return (
    <Layout2 items={auditNav.items} navTitle={auditNav.header}>
        <div className="d-flex flex-column w-100">
            <PageHeader title={'Users Audit'} />
            <div className='px-4 py-4 d-flex'>
                <form onSubmit={handleSubmit}>
                    <span className="p-input-icon-left me-2">
                        <i className="pi pi-search" />
                        <InputText
                            placeholder="Search..."
                            type='search'
                            value={filter}
                            onChange={(e) => setFilter(e.target.value)}
                            style={{ height: "38.48px" }}
                        />
                    </span>
                </form>
            </div>
            <div className='px-4 py-2'>
                {isLoading ? (
                    <Loader />
                ) : (
                    <DataTable
                        className="customerTable thead-dark"
                        tableStyle={{ tableLayout: 'fixed' }} 
                        totalRecords={totalRecords}
                        lazy
                        paginator
                        sortField={sortField}
                        sortOrder={sortOrder}
                        onSort={(e) => {
                            if (!e.sortField && e.sortOrder === 0) {
                                handleSorting({ sortField: 'created_at', sortOrder: -1 });
                            } else {
                                handleSorting(e);
                            }
                        }}
                        removableSort
                        rows={rowsPerPage}
                        value={auditList}
                        first={(currentPage - 1) * rowsPerPage}
                        onPage={onPageChange}
                        dataKey="id"
                        emptyMessage="No audits found."
                        paginatorLeft={
                            <Dropdown value={rowsPerPage} options={[10, 25, 50]} onChange={(e) => setRowsPerPage(e.value)} />
                        }
                    >
                      <Column
                          field="userName"
                          header="NAME"
                          sortable
                          filterField="first_name"
                          style={{ width: '16%' }}
                      />
                      <Column
                          field="description"
                          header="DESCRIPTION"
                          body={(rowData) => (
                              <div className="d-flex align-items-center">
                                  <span className='me-2'>{rowData.description}</span>
                              </div>
                          )}
                          sortable
                          filterField="description"
                          style={{ width: '17%' }}
                      />
                      <Column
                          field="created_at"
                          header="DATE"
                          sortable
                          filterField="created_at"
                          style={{ width: '17%' }}
                      />
                      <Column
                          field="data"
                          header="DATA"
                          sortable
                          filterField="data"
                          style={{ width: '50%' }}
                          body={(rowData) => (
                              <div
                                style={{
                                  whiteSpace: 'normal',
                                  overflowWrap: 'break-word',
                                  wordBreak: 'break-word',
                                }}
                              >
                                  {rowData.data}
                              </div>
                          )}
                      />
                    </DataTable>
                )}
            </div>
        </div>
    </Layout2>
  )
}

export default Audit